import { Box, Typography, Divider } from "@mui/material";

const FormHeader = () => {
  return (
    <Box pb={4}>
      {/* Container for text and logo */}
      <Box
        display="flex"
        justifyContent="space-evenly"
        alignItems="center"
        flexDirection={{ xs: "column", sm: "row" }} // Stack vertically on small screens
      >
        {/* Text Section (left aligned) */}
        <Typography
          variant="h3"
          gutterBottom
          color={"red"}
          fontWeight={600}
          textAlign={{ xs: "center", sm: "left" }} // Center text on small screens
          sx={{
            fontSize: { xs: "h4.fontSize", sm: "h3.fontSize" }, // Adjust font size responsively
          }}
        >
          RETAILER <br />
          APPLICATION FORM
        </Typography>

        {/* Logo Section (right aligned) */}
        <Box>
          <img
            src="https://hello.groceryshop.com/hubfs/Groceryshop/Website-Content/Media-Partners/Logos/b5a15e24-f4e9-46f0-88e9-f9aecc43fb5f.png"
            alt="Logo"
            style={{ height: "auto", maxHeight: 100 }} // Ensure the logo is responsive
          />
        </Box>
      </Box>

      {/* Divider below text and image */}
      <Divider
        color={"red"}
        variant="fullWidth"
        sx={{
          borderBottomWidth: 2,
          marginTop: 2, // Add spacing above the divider
        }}
      />
    </Box>
  );
};

export default FormHeader;
